import fetch from '../utils/fetch'
// 分类
export function getCategoryList(query) {
  return fetch({
    url: '/long/category/list',
    method: 'get',
    params: query
  })
}
export function saveCategory(params) {
  return fetch({
    url: '/long/category/save',
    method: 'post',
    data: params
  })
}

export function updateCategory(id,query) {
  return fetch({
    url: '/long/category/edit'+id,
    method: 'put',
    params: query
  })
}

export function deleteCategory(id) {
  return fetch({
    url: '/long/category/' + id,
    method: 'delete'
  })
}

// ~~~~~~~~~~~商品~~~~~~~~~~
  export function getGoodsList(query) {
    return fetch({
      url: '/long/goods/list',
      method: 'get',
      params: query
    })
  }
export function getGoodsRow(id) {
  return fetch({
    url: '/long/goods/getrow/'+id,
    method: 'get',
  })
}
  export function saveGoods(params) {
    return fetch({
      url: '/long/goods/save',
      method: 'post',
      data: params
    })
  }

  export function updateGoods(id,query) {
    return fetch({
      url: '/long/goods/edit'+id,
      method: 'put',
      params: query
    })
  }

  export function deleteGoods(id) {
    return fetch({
      url: '/long/goods/'+id,
      method: 'delete'
    })
}

export function getSignList(query) {
  return fetch({
    url: '/long/sign/list',
    method: 'get',
    params: query
  })
}

export function deleteSign(id) {
  return fetch({
    url: '/long/sign/'+id,
    method: 'delete'
  })
}
export function getCouponList(query) {
  return fetch({
    url: '/long/couponlogs/list',
    method: 'get',
    params: query
  })
}
export function changeStatus(params) {
  return fetch({
    url: '/long/goods/changestatus',
    method: 'post',
    data: params
  })
}
export function getInviteList(query) {
  return fetch({
    url: '/long/invite/list',
    method: 'get',
    params: query
  })
}
// ---------------长合约拓展厂家-------------------
// 添加
export function addManufactor(params) {
  return fetch({
    url: '/long/manufactor/add',
    method: 'post',
    data: params
  })
}
// 列表
export function getManufactorList(query) {
  return fetch({
    url: '/long/manufactor/list',
    method: 'get',
    params: query
  })
}
// 删除
export function deleteManufactor(id) {
  return fetch({
    url: '/long/manufactor/' + id,
    method: 'delete'
  })
}
// 财务对账列表
export function getManufactorLogList(query) {
  return fetch({
    url: '/long/manufactor/report_from',
    method: 'get',
    params: query
  })
}
export function getListExpord(params) {
  return fetch({
    url: '/long/manufactor/report_from',
    method: 'post',
    data: params
  })
}



// WEBPACK FOOTER //
// ./src/api/long.js